import * as UnitDivide from "../unit-divide";
import { Kilojoule, Btu } from "./energy";
import { KiloWattHour } from "./energy2";
import { CubicMeter, CubicFeet } from "./volume";
// Energy per volume
export var KiloWattHourPerCubicMeter = UnitDivide.energyByVolume("KiloWattHourPerCubicMeter", KiloWattHour, CubicMeter);
export var KiloJoulePerCubicMeter = UnitDivide.energyByVolume("KiloJoulePerCubicMeter", Kilojoule, CubicMeter);
export var BtuPerCubicFeet = UnitDivide.energyByVolume("BtuPerCubicFeet", Btu, CubicFeet);
//# sourceMappingURL=heating-value.js.map